var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1687.713,
    height: 736.042,
    viewBox: "0 0 1687.713 736.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.117,
    y1: -0.905,
    x2: 9.128,
    y2: -0.893,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6aa7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ce68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 28.97,
    y1: -6.493,
    x2: 28.955,
    y2: -6.507,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4495d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ebc83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.454,
    y1: 1.101,
    x2: 2.449,
    y2: 1.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea5494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20.156,
    y1: 0.742,
    x2: 20.172,
    y2: 0.759,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315ca7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg_pattern",
    "data-name": "bg pattern",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    d: "M11.184,22.385C-15.705,88.317,9.935,205.03,45.315,212.522c15.817,3.33,47.867-6.077,79.585-21.062,39.126-18.564,77.5-45.869,83-68.18,4.995-20.229-33.882-69.1-79.834-97.4C80.529-3.838,25-11.746,11.184,22.385",
    transform: "translate(1476.82 520.334)",
    fill: "none",
    stroke: "#eb5a87",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    d: "M11.184,22.385C-15.705,88.317,9.935,205.03,45.315,212.522c15.817,3.33,47.867-6.077,79.584-21.062,39.126-18.564,77.5-45.869,83-68.179,4.995-20.229-33.882-69.1-79.834-97.4C80.529-3.838,25-11.746,11.184,22.385",
    transform: "translate(284.135 19.518)",
    fill: "none",
    stroke: "#c779b0",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    d: "M62.023.448C37.215-3.131-.413,15.516,0,28.253c.25,5.661,6.16,15.817,13.986,25.39,9.657,11.738,22.227,22.56,30.3,22.477,7.326,0,20.729-17.482,26.473-35.547C76.924,21.843,74.843,2.2,62.023.448",
    transform: "translate(1465.191 329.657)",
    fill: "none",
    stroke: "#5dbca3",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    d: "M71.234,39.6C63.325,17.708,31.608-5.019,21.452.975c-4.579,2.664-10.323,11.9-14.735,22.477C1.306,36.521-2.107,51.506,1.472,58.082c3.247,5.994,23.309,9.324,40.625,6.16C60.162,61.079,75.4,50.84,71.234,39.6",
    transform: "translate(924.695 207.506)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    d: "M30.009,56.782c16.4-10.239,29.47-39.959,22.81-47.2-2.914-3.247-11.488-6.327-20.9-8.075C20.353-.659,7.532-.826,2.787,3.254c-4.329,3.663-3.58,20.562,2,34.131,5.827,14.069,16.816,24.724,25.224,19.4",
    transform: "translate(0 523.316)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    d: "M1.806,57.8C20.2,101.591,87.384,144.63,107.7,131.394c20.229-13.236,49.033-95.235,34.548-118.877C135.085.612,93.628-4.133,58.58,4.192,22.118,12.766-7.768,35.243,1.806,57.8",
    transform: "translate(1225.551 0)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    d: "M.644,20.61C7.22,36.26,31.2,51.578,38.355,46.833,45.6,42.087,55.837,12.868,50.675,4.46c-2.581-4.246-17.315-5.911-29.8-3C7.886,4.543-2.769,12.535.644,20.61",
    transform: "translate(535.593 110.035)",
    fill: "url(#linear-gradient-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern);
export default __webpack_public_path__ + "static/media/bg_pattern.23127540f8fb7ced43070ab1be0edee4.svg";
export { ForwardRef as ReactComponent };